<template>
    <div class="app_container">
                <el-form :rules="rules" ref="form" :model="form" label-width="80px" class="event-form">
                    <el-row v-if="type=='add'">
                        <el-col :span="18">
                            <el-form-item label="变更模板" >
                                <el-select v-model="chaTemplateId" @change="getChaTemplate">
                                    <el-option v-for="item in chaTemplateList" :key="item.id" :value="item.id" :label="item.title"></el-option>
                                </el-select>
                                <span style="margin-left: 20px;color: #1890ff;">建议使用模板简化您的操作&nbsp;(非必选)</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="所属公司" prop="company">
                                <el-select v-model="form.company" placeholder="请选择" filterable>
                                    <el-option v-for="item in companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="报告人">
                                <div>
                                    <el-input type="text" placeholder="请选择报告人" disabled v-model="form.requester.name" class="form-common mr10"></el-input>
                                    <router-link :to="{ path:'/requesterList',query: { enable:true, callback:getReporter} }">
                                        <el-button type="primary" class="iconfont icon-gengduo icon"></el-button>
                                    </router-link>
                                    <el-button type="primary" :type="userTasksTotal>=5?'danger':'success'" plain >人员繁忙度  ({{userTasksTotal}})</el-button>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="变更类型" prop="changeType">
                                <el-select v-model="form.changeType" placeholder="请选择" @change="changeTypeEvent">
                                    <el-option v-for="item in changeType" :key="item.id" :label="item.cname" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="变更分类" prop="category">
                                <el-select v-model="form.category" placeholder="请选择" >
                                    <el-option v-for="item in categoryList" :key="item.id" :label="item.title"
                                               :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="项目名称" prop="projectName">
                                <el-select v-model="form.projectName" placeholder="请选择" filterable @change="projectNameEvent">
                                    <el-option v-for="item in projectName" :key="item.id" :label="item.cname" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="服务请求" prop="serviceClass">
                                <el-select v-model="form.serviceClass" placeholder="请选择" filterable>
                                    <el-option v-for="item in serviceClass" :key="item.id" :label="item.cname" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="项目二线">
                                <div>
                                    <el-input type="text"
                                              placeholder="请选择项目二线"
                                              disabled v-model="projectUserName"
                                              class="form-common mr10"></el-input>
                                    <router-link :to="{ path:'/requesterList',query: { enable:true, callback:(val)=>getRequester(val,'projectUser') } }">
                                        <el-button type="primary" class="iconfont icon-gengduo icon"></el-button>
                                    </router-link>
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="" prop="">

                            </el-form-item>
                        </el-col>
                    </el-row>
                    <!-- 环境 -->
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="环境" prop="env">
                                <el-select v-model="form.env" placeholder="请选择" filterable @change="envChangeEvent">
                                    <el-option v-for="item in env" :key="item.id" :label="item.cname" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <!-- 开始时间 -->
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="开始时间" prop="startTime">
                                <el-date-picker
                                    v-model="form.startTime"
                                    type="datetime"
                                    placeholder="选择日期时间"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    @change="deployTimeEvent"
                                    :picker-options="pickerOptions"
                                    class="form-common"
                                >
                                </el-date-picker>
                            </el-form-item>

                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="完成时间"  class="endTime" prop="endTime">
                                <el-date-picker
                                    v-model="form.endTime"
                                    type="datetime"
                                    placeholder="选择日期时间"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    @change="compareTime"
                                    class="form-common"
                                >
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="变更标题" prop="title">
                                <el-input v-model="form.title" class="common-input"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" v-if="this.type != 'add'">
                            <el-form-item label="编号">
                                <el-input type="text" disabled placeholder="请输入编号" v-model="form.serialNumber" ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <!-- 相关知识 -->
                            <div style="width:820px;float: right">
                                <knowledge ref="knowledge" :keyword="form.title" type="event"></knowledge>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="详细描述">

                                <ueditor v-model="form.description" :config="myConfig" :key="1" :value="2" @ready="editorReady"></ueditor>
                            </el-form-item>
                        </el-col>
                    </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="优先级" prop="priority">
                            <el-select v-model="form.priority" placeholder="请选择">
                                <el-option v-for="item in priority" :key="item.id" :label="item.cname" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="变更来源" prop="changeOrigin">
                            <el-select v-model="form.changeOrigin" placeholder="请选择">
                                <el-option v-for="item in changeOrigin" :key="item.id" :label="item.cname" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="影响范围" prop="influence">
                            <el-select v-model="form.influence" placeholder="请选择">
                                <el-option v-for="item in influence" :key="item.id" :label="item.cname" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="紧急度" prop="emergency">
                            <el-select v-model="form.emergency" placeholder="请选择">
                                <el-option v-for="item in emergency" :key="item.id" :label="item.cname" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="风险等级" prop="risk">
                            <el-select v-model="form.risk" placeholder="请选择" >
                                <el-option v-for="item in risk" :key="item.id" :label="item.cname"
                                           :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="关联事件">
                                <router-link :to="{ path: '/relevancyEvent',query: { callback:relevancyEvent,data:form.toEvent }}">
                                    <el-button type="primary">新增</el-button>
                                </router-link>
                                <relevancy-tab :data="form.toEvent" :getData="getEventData"></relevancy-tab>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="关联问题">
                                <router-link :to="{ path: '/relevancyProblem',query:{callback:relevancyProblem}}">
                                    <el-button type="primary">新增</el-button>
                                </router-link>
                                <relevancy-tab :data="form.toProblem" :getData="getProblemData"></relevancy-tab>
                            </el-form-item>
                        </el-col>

                        <el-col :span="6">
                            <el-form-item label="关联变更">
                                <router-link :to="{ path: '/relevancyChange',query: { callback:relevancyChange }}">
                                    <el-button type="primary">新增</el-button>
                                </router-link>
                                <relevancy-tab :data="form.toChange" :getData="getChangeData"></relevancy-tab>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="关联发布">
                                <router-link :to="{ path: '/relevancyDeploy',query: { callback:relevancyDeploy }}">
                                    <el-button type="primary">新增</el-button>
                                </router-link>
                                <relevancy-tab :data="form.toDeploy" :getData="getDeployData"></relevancy-tab>
                            </el-form-item>
                        </el-col>

                    </el-row>
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="关联服务">
                                <router-link :to="{ path: '/relevancyService',query:{callback:relevancyService}}">
                                    <el-button type="primary">新增</el-button>
                                </router-link>
                                <relevancy-tab :data="form.toService" :getData="getServiceData"></relevancy-tab>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="关联配置项">
                                <router-link :to="{ path: '/relevancyConfig',query:{callback:relevancyConfig}}">
                                    <el-button type="primary">新增</el-button>
                                </router-link>
                                <relevancy-tab :data="form.toCmdb" :getData="getCmdbData"></relevancy-tab>
                            </el-form-item>
                        </el-col>
                    </el-row>
                <!--标签-->
                 <el-row>
                     <newTag :dadLabel="form.label" v-on:getLabelFromSon="getLabelFromSon"></newTag>
                 </el-row>
                    <el-form-item label="变更影响">
                        <el-input
                            type="textarea"
                            :rows="2"
                            placeholder="请输入内容"
                            v-model="form.influenceDes">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="上线计划">
                        <el-input
                            type="textarea"
                            :rows="2"
                            placeholder="请输入内容"
                            v-model="form.deployPlan">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="回退计划">
                        <el-input
                            type="textarea"
                            :rows="2"
                            placeholder="请输入内容"
                            v-model="form.rollbackPlan">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="测试计划">
                        <el-input
                            type="textarea"
                            :rows="2"
                            placeholder="请输入内容"
                            v-model="form.testPlan">
                        </el-input>
                    </el-form-item>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="实施方案" >
                                <ueditor v-model="form.implementPlan" :config="myConfig" :key="1" :value="2" @ready="editorReady1"></ueditor>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <!--附件-->
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="附件">
                                <inputFile :data="attachment" :getFiles="getFiles"></inputFile>
                            </el-form-item>
                        </el-col>
                    </el-row>

                <el-form-item v-if="type=='add'">
                    <el-button type="primary" size="small" @click="submit('create_commit')" :disabled="isSubmit">{{ type == "edit" ? '确定' : "创建并提交"}}</el-button>
                    <el-button type="primary" size="small" @click="submit('create')" :disabled="isSubmit">{{ type == "edit" ? '确定' : "创建"}}</el-button>
                    <el-button type="default" size="small" @click="onCancel">取消</el-button>
                </el-form-item>
                <el-form-item v-else>
                    <el-button type="primary" size="small" @click="submit('create')" :disabled="isSubmit">{{ type == "edit" ? '确定' : ""}}</el-button>
                    <el-button type="default" size="small" @click="onCancel">取消</el-button>
                </el-form-item>

                </el-form>
    </div>
</template>

<script>
    const VueUeditorWrap = window.VueUeditorWrap;
    import Config from "../../app.config";

    import commonService from "../../services/common.service"
    import relevancyTab from "../common/relevancyTab.vue"
    import newTag from '../common/newTag'
    import services from "./change.service";
    import knowledge from "../../components/knowledge.vue"
    import inputFile from "../common/inputFile.vue"
    import ueditor from "../../components/ueditor.vue"

    import { getRules } from "./change.rules";
    const rules = getRules();
    export default {
        props:{
            type:{
                type:String,
                default:"add"
            },
            serialNumber:String,
            parentNumber:String,
            callback:Function,
            parentParams:Object,
        },
        components:{ knowledge , ueditor ,newTag,relevancyTab,inputFile},
        data() {
            return {
                pickerOptions: {
                  disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;//如果没有后面的-8.64e7就是不可以选择今天的
                 }
                },
                formName:"form",
                form:{
                    company:"",

                    changeType:"",
                    category:"",//变更分类
                    requester:'',
                    title:"",
                    description:"",

                    startTime:'',
                    endTime:"",
                    emergency:"",
                    priority:"",
                    risk:"",
                    changeOrigin:"",
                    influence:"",
                    label:[],
                    keyword:'',
                    deployPlan:"",
                    influenceDes:"",
                    rollbackPlan:"",
                    testPlan:"",
                    implementPlan:"",
                    attachment:[],
                    toEvent:[],
                    toChange:[],
                    toDeploy:[],
                    toProblem:[],
                    toCmdb:[],
                    toService:[],
                    projectName:'',
                    projectUser:'',//项目二线
                    serviceClass:'',
                    env:'',

                },
                projectUserName:'',
                myConfig: {
                    autoHeightEnabled: false,
                    initialFrameHeight: 200,
                    initialFrameWidth: '100%',
                    UEDITOR_HOME_URL: '/UEditor/',
                    serverUrl:Config.BASE_API + "upload/",
                },
                editMode:true,
                defaultUserInfo:{},
                department:"",//报告人部门信息
                reporterName:'',  //报告人姓名
                reporterId:'',     //报告人id
                attachment:[],    // 存放上传的附件
                companyList:[],   // 公司列表
                categoryList:[],  //变更分类
                toEventId:[],     //
                toEventName:[],

                toChangeId:[],
                toChangeName:[],

                toDeployId:[],
                toDeployName:[],

                toProblemName:[],
                toProblemId:[],

                toConfigName:[],
                toConfigId:[],

                toServiceName:[],
                toServiceId:[],

                rules:rules,
                isKnowledge:false,
                userTasksTotal:'',  //人员任务数
                isSubmit:false,
                chaTemplateId:null,//新增时选择变更模板
                chaTemplateList:[],
            }
        },
        created() {
            this.getCompanyList();
            this.getCategoryList();
            this.getChaTemplateList()
        },
        mounted(){
            if(this.type!=='edit'&&!this.parentNumber){
                this.getDefaultUser()
            }
            if(this.type == "edit"){
                this.$modal.title = "修改变更"
                this.editMode=false
                setTimeout(()=>{
                    this.getDetail()
                },100)
            }
            if (this.parentNumber) {
                this.$modal.title='提交为变更'
                if (this.parentParams){
                    setTimeout(()=>{
                        this.getCmdbService()
                    },100)
                }else{
                    setTimeout(()=>{
                        this.getDetails()
                    },100)
                }
            }
        },
        computed:{
            dictionary(){
                return this.$store.state.dictionary;
            },
            //变更类型
            changeType(){
                return this.dictionary.change_type;
            },

            changeTypeId(){
                return this.$store.state.caseType.change;
            },
            //变更来源
            changeOrigin(){
                return this.dictionary.change_origin;
            },
            // 紧急度
            emergency(){
                return this.dictionary.emergency;
            },
            // 优先级
            priority(){
                return this.dictionary.priority;
            },
            //风险等级
            risk(){
                return this.dictionary.change_risk
            },

            // 影响范围
            influence(){
                return this.dictionary.influence;
            },
            //环境
            env(){
                return this.dictionary.env
            },
            //项目名称
            projectName(){
                return this.dictionary.project_name
            },
            //服务请求
            serviceClass(){
                return this.dictionary.service_class
            },
        },
        methods: {
            //改变项目名称
            projectNameEvent(val){
                let data = this.projectName.filter((item,index)=>{
                    return item.id == val
                })
                this.form.projectUser = data[0].user_id
                this.projectUserName = data[0].user_name
            },
            // 选择的请求人
            getRequester(obj,str){
                if(str == 'projectUser'){
                    this.form.projectUser = obj.internalUserid
                    this.projectUserName = obj.name
                }else{
                    this.requesterInfo = {
                        id:obj.internalUserid,
                        name:obj.name,
                        department:obj.department.id
                    };
                    this.form = {
                        ...this.form,
                        requesterName: obj.name,
                        department:obj.department.id
                    }
                    this.getUserBusyness( this.requesterInfo.id )
                }

            },
            getUserBusyness(id){
                services.busynessUser(id).then(res => {
                    this.userTasksTotal= res.tasksTotal;
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
            editorReady (editorInstance) {
                editorInstance.setContent('你可以在这里初始化编辑器的初始内容。');
                let _this = this
                editorInstance.addListener('contentChange', () => {
                   _this.form.description = editorInstance.getContent()
                });
            },
            editorReady1 (editorInstance) {
                editorInstance.setContent('你可以在这里初始化编辑器的初始内容。');
                let _this = this
                editorInstance.addListener('contentChange', () => {
                   _this.form.implementPlan = editorInstance.getContent()
                });
            },
            //变更类型事件
            changeTypeEvent(val){
                //199例行变更，459重大变更类型, 200快速变更, 201紧急变更
                // 例行、重大  + prod环境=T+2
                // 快速+prod环境=T+1
                // 紧急+prod环境=T
                // 非PROD环境=T+1
                    this.envProFlag(this.form.env)
            },
            //环境事件
            envChangeEvent(val){
                this.form.startTime = ''
                this.envProFlag(val)
            },
            //环境中文名判断是否为生产环境
            envProFlag(val){

                if(val !== ''){
                    this.env.map(item=>{
                        if(item.id == val){
                            var res = RegExp(/PRO/)
                            if(res.test(item.cname)){//生产
                                //例行、重大  + prod环境=T+2
                                if(this.form.changeType == 199 || this.form.changeType == 459){
                                    this.pickerOptions = {
                                      disabledDate(time) {
                                        return time.getTime() < Date.now() + 8.64e7;
                                     }
                                    }
                                }else if(this.form.changeType == 200){
                                    this.pickerOptions = {
                                      disabledDate(time) {
                                        return time.getTime() < Date.now();
                                     }
                                    }
                                }else if(this.form.changeType == 201){
                                    this.pickerOptions = {
                                      disabledDate(time) {
                                        return time.getTime() < Date.now() - 8.64e7;
                                     }
                                    }
                                }
                            }else{
                                //非PROD环境=T+1
                                if(this.form.changeType == 201){
                                    this.pickerOptions = {
                                      disabledDate(time) {
                                        return time.getTime() < Date.now() - 8.64e7;
                                     }
                                    }
                                }else{
                                    this.pickerOptions = {
                                      disabledDate(time) {
                                        return time.getTime() < Date.now();
                                     }
                                    }
                                }
                            }
                        }//最外层if  end
                    }) //===========mapend
                }else{
                    // console.log('环境为空')
                    //类型为紧急
                    if(this.form.changeType == 201){
                        this.pickerOptions = {
                            disabledDate(time) {
                                return time.getTime() < Date.now() - 8.64e7;
                            }
                        }
                    }else{
                        //环境为空并且类型为例行和重大
                        this.pickerOptions = {
                            disabledDate(time) {
                                return time.getTime() < Date.now();
                            }
                        }
                    }

                }

            },
            //选择开始时间判断环境和发布类型
            deployTimeEvent(val){
                if(this.form.changeType =='' || this.form.env==''){
                    this.$message.error('请选择变更类型和环境，再选择开始时间')
                    this.form.startTime=''
                }
            },
           //开始时间和完成时间的对比校验
            CompareDate(d1,d2) {
                //将所有的短横线替换为斜杠
                return ((new Date(d1.replace(/-/g,"\/"))) > (new Date(d2.replace(/-/g,"\/"))));
            },
            compareTime(){
                let d1=this.form.startTime?this.form.startTime:''
                let d2=this.form.endTime?this.form.endTime:''
                if (this.form.startTime&&this.form.endTime) {
                    let timeCompare=this.CompareDate(d1,d2)
                    if(timeCompare){
                        this.$message.error('完成时间应比开始时间晚，请重新选择')
                        this.form.endTime=''
                    }
                }


            },
            //获取变更分类
            getCategoryList(){
                commonService.categoryList(this.changeTypeId.id).then(res => {
                    this.categoryList = res;
                })
            },
            getChaTemplateList(){
                services.getChaTemplateList({type:'change'}).then(res=>{
                    this.chaTemplateList=res
                })
            },
            getChaTemplate(){

                services.getChaTemplate(this.chaTemplateId).then(res=>{
                    this.form={
                        ...this.form,
                        ...res.data
                    }
                    //给desscription添加一个后缀用以区分,这个后缀要具备唯一性
                    this.form.description=this.form.description+'默认的模板'
                    this.form.category = this.form.category?+this.form.category:''
                })
            },
            //新增时，报告人/申请人默认选取当前用户
            getDefaultUser(){
                let userId = window.localStorage.getItem('internalUserid')
                let params={
                    internalUserid:userId
                }

                commonService.getUserDetail(params).then(res =>{
                    for (let i in res){
                        this.defaultUserInfo=res[i]
                    }

                    this.form.requester = this.defaultUserInfo;
                    this.reporterId = this.defaultUserInfo.internalUserid;
                    this.department=this.defaultUserInfo.department
                    this.getUserBusyness(this.reporterId)
                })

            },

            getLabelFromSon(val){
                this.form.label=val
            },
            getUeContent(val){
                this.form.description = val;
            },
            getUeContent_imp(val){
                this.form.implementPlan=val;
            },
            getFiles(val){
                this.attachment = val;
            },
            submit(handleStr){
                let formName = this.formName;
                this.$refs[formName].validate((valid) => {
                    if(valid){
                        this.isSubmit=true
                            if (this.parentParams){
                                this.getRelevancyId()
                                let params ={
                                    ...this.form,
                                    createUser:window.localStorage.getItem('internalUserid'),
                                    requester:this.reporterId,
                                    toEvent:this.toEventId,          // 关联事件
                                    toChange:this.toChangeId,        // 关联变更
                                    toProblem:this.toProblemId,     // 关联问题
                                    toDeploy:this.toDeployId,       // 关联发布
                                    toCmdb:this.toConfigId,         // 关联配置项
                                    toService:this.toServiceId,     // 关联服务
                                }

                                this.addChange(params)

                            } else {
                                let params = this.getParams();
                                if(this.type == 'edit'){
                                    this.updateChange(params);
                                }else{
                                    params.handle = handleStr
                                    this.addChange(params);
                                }
                            }

                    }else{
                        this.isSubmit=false
                        this.$message.error('✳为必填项，请全部填写')
                    };
                    return valid;
                })
            },
            // 获取所属公司列表
            getCompanyList(){
                commonService.companyList().then(res => {
                    this.companyList = res.list;
                })
            },



            // 详情默认显示
            getDetail(){
                services.detail({ serialNumber:this.serialNumber}).then(res => {
                    this.form =  {...res};
                    this.attachment=res.attachment
                    this.form.category=+this.form.category
                    this.reporterId = this.form.requester&&this.form.requester.internalUserid
                    this.form.projectUser = res.projectUser.userid?res.projectUser.userid:'';
                    this.projectUserName = res.projectUser.name?res.projectUser.name :'';
                    this.getRelevancyId()
                    this.getUserBusyness(this.reporterId )

                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
            // 提交时详情默认显示
            getDetails(){
                commonService.getCorrectDetail({ serialNumber:this.parentNumber}).then(res => {
                    // console.log(res,'这是提交时获取到的数据');
                    this.form = {...res};
                    //只有从变更过来的提交为变更，才能正确展示变更分类和风险等级，其他都置空
                    let sn=this.parentNumber
                    this.form.category=sn.indexOf('Cha')>-1?+res.category:"";
                    this.form.risk=sn.indexOf('Cha')>-1?res.risk:""
                    this.form.projectUser = res.projectUser.userid?res.projectUser.userid:'';
                    this.projectUserName = res.projectUser.name?res.projectUser.name :'';
                    this.form.origin = "";

                    this.reporterId = this.form.requester && this.form.requester.internalUserid

                    this.attachment=this.form.attachment
                    this.getUserBusyness(this.reporterId )
                    if (!res.label){
                        this.form.label=[]
                    }

                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
            getCmdbService(){
                this.form={
                    ...this.form,
                    ...this.parentParams,
                    requester:{},
                    mainCase:this.parentNumber,
                }
                let toCmdb=this.parentParams.toCmdb.filter(item =>item.serialNumber===this.parentNumber)
                if (!toCmdb.length){
                    this.form.toCmdb.push({
                        serialNumber:this.parentNumber,
                        title: this.form.title
                    })
                }
                this.attachment=this.form.attachment

                this.getRelevancyId()
            },
            getParams(){
                this.getRelevancyId()
                let params = {
                    ...this.form,
                    createUser:this.type=='edit'?this.form.createUser:window.localStorage.getItem('internalUserid'),
                    requester:this.reporterId,
                    department:this.department?this.department.toString():this.form.department,
                    attachment:this.attachment,      // 附件
                    toEvent:this.toEventId,          // 关联事件
                    toChange:this.toChangeId,        // 关联变更
                    toProblem:this.toProblemId,     // 关联问题
                    toDeploy:this.toDeployId,       // 关联发布
                    toCmdb:this.toConfigId,         // 关联配置项
                    toService:this.toServiceId,     // 关联服务
                };
                if(this.parentNumber){
                    params.mainCase = this.parentNumber;
                }
                return params;
            },
            getRelevancyId(){
                this.toEventId=this.form.toEvent&&this.form.toEvent.map(item => {return item.serialNumber})

                this.toChangeId=this.form.toChange&&this.form.toChange.map(item => {return item.serialNumber})

                this.toProblemId=this.form.toProblem&&this.form.toProblem.map(item => {return item.serialNumber})

                this.toDeployId=this.form.toDeploy&&this.form.toDeploy.map(item => {return item.serialNumber});
                this.toConfigId=this.form.toCmdb&&this.form.toCmdb.map(item => {return item.serialNumber});
                this.toServiceId=this.form.toService&&this.form.toService.map(item => {return item.serialNumber})
            },
            // 创建变更
            addChange(params){
                    services.addChange(params).then(res => {
                        this.$message.success("变更创建成功");
                        this.close(true);
                    }).catch(err => {
                        this.isSubmit=false
                        this.$message.error(err.message);
                    })

            },
            // 修改变更
            updateChange(params){
                services.updateChange(params).then(res => {
                    this.$message.success("变更修改成功");
                    this.close(true);
                }).catch(err => {
                    this.isSubmit=false
                    this.$message.error(err.message);
                })
            },
            // 公司--部分级联菜单
            companyChange(value) {
                this.form.company = value[0];
                this.form.department = value[1];
            },
            // 选择的报告人
            getReporter(obj){
                // console.log(obj,'选中的报告人');
                this.form.requester = obj;
                this.reporterId = obj.internalUserid;
                this.department=obj.department.id
                this.getUserBusyness( this.reporterId )
            },

            // 标题自动匹配知识库
            getKnowledge(){
                this.isKnowledge = this.form.title ? true : false;
            },


            //上传文件
            fileChange(e){
                let files = e.target.files || e.dataTransfer.files;

                if (!files.length){
                    return;
                }
                let params = {
                    file_name:files[0]
                };
                commonService.uploading(params).then(res => {
                    let file =  res;
                    this.attachment.push({
                        name:file.file_name,
                        url:file.download_url
                    })
                }).catch( err => {
                    this.$message.error(err.message);
                })
            },
            onCancel(){
                this.close();
            },
            close(refresh) {
                this.$modal.close();
                refresh && refresh === true ? this.callback() : '';
            },
            //选择完关联项后去重，此方法可通用于包含对象的数组深层次去重
            arrayUnique(arr){
                let obj={}
                let newArr = []
                arr.forEach(item=>{
                    if(!obj[item.serialNumber]){
                        obj[item.serialNumber]=1
                        newArr.push(item)
                    }
                })
                return newArr
            },

            // 获取选择后的关联的事件
            relevancyEvent(val){
                this.form.toEvent=this.arrayUnique(this.form.toEvent.concat(val))
                val.forEach(item => {
                    this.toEventName.push(item.title);
                    this.toEventId.push(item.serialNumber);
                });
            },
            // 获取选择后的关联的变更
            relevancyChange(val){
                this.form.toChange=this.arrayUnique(this.form.toChange.concat(val))
                val.forEach(item => {
                    this.toChangeName.push(item.title);
                    this.toChangeId.push(item.serialNumber);
                });
            },

            // 获取选择后的关联的发布
            relevancyDeploy(val){
                this.form.toDeploy=this.arrayUnique(this.form.toDeploy.concat(val))
                val.forEach(item => {
                    this.toDeployName.push(item.title);
                    this.toDeployId.push(item.serialNumber);
                });
            },

            // 获取选择后的关联的问题
            relevancyProblem(val){
                this.form.toProblem=this.arrayUnique(this.form.toProblem.concat(val))
                val.forEach(item => {
                    this.toProblemName.push(item.title);
                    this.toProblemId.push(item.serialNumber);
                });
            },
            //获取选择后的关联的配置项
            relevancyConfig(val){
                this.form.toCmdb=this.arrayUnique(this.form.toCmdb.concat(val))
                val.forEach(item => {
                    this.toConfigName.push(item.title);
                    this.toConfigId.push(item.serialNumber);
                });
            },
            //获取选择后的关联的服务
            relevancyService(val){

                this.form.toService=this.arrayUnique(this.form.toService.concat(val))
                val.forEach(item => {
                    this.toServiceName.push(item.title);
                    this.toServiceId.push(item.serialNumber);

                });
            },
            getEventData(val){ this.form.toEvent = val;},
            getCmdbData(val){ this.form.toCmdb = val;},
            getServiceData(val){ this.form.toService = val;},
            getChangeData(val){ this.form.toChange = val;},
            getDeployData(val){ this.form.toDeploy = val;},
            getProblemData(val){ this.form.toProblem = val;},
        }
    }
</script>

<style scoped lang="scss"  rel="stylesheet/scss">

</style>
